module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAPCAYAAADQ4S5JAAAAAXNSR0IArs4c6QAAAGRJREFUKFNjzBfe/J8BD/j/n6Fh0jvfRpgSRpCGiW99GXHpAckjayJKAwMDw9X//xlWg2wiVgPYASCbCGpAdirIeSga0AMA3W8YGvCFFkiOcg244gTmNMptINkPg8hJhNyOLA8AW/9y/sV27YsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fileP.png
// module id = 421
// module chunks = 0